import { render, staticRenderFns } from "./DistribuicaoEstoque.vue?vue&type=template&id=d0eb494a"
import script from "./DistribuicaoEstoque.vue?vue&type=script&lang=js"
export * from "./DistribuicaoEstoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports